import { api } from "./client";

export type RecipientStatus =
  | "queued"
  | "sent"
  | "read"
  | "replied"
  | "followed_up"
  | "failed";

export type CampaignSummary = {
  id: string;
  groupId: string;
  subject: string;
  personalize: boolean;
  status: string;
  createdAt: string;
  recipientCount: number;
};

export type CampaignRecipient = {
  id: string;
  contactId: string;
  email: string;
  name: string | null;
  status: RecipientStatus;
  sentAt: string | null;
  readAt: string | null;
  repliedAt: string | null;
  followedUpAt: string | null;
  error: string | null;
  gmailThreadId: string | null;
  threadId: string | null;
  hasUnreadReply: boolean;
};

export type CampaignDetail = {
  id: string;
  subject: string;
  bodyTemplate: string;
  personalize: boolean;
  status: string;
  createdAt: string;
  group: { id: string; name: string };
  counts: Partial<Record<RecipientStatus, number>>;
  recipients: CampaignRecipient[];
};

export function listCampaigns(groupId?: string): Promise<{ campaigns: CampaignSummary[] }> {
  const qs = groupId ? `?groupId=${groupId}` : "";
  return api(`/campaigns${qs}`);
}

export function getCampaign(id: string): Promise<{ campaign: CampaignDetail }> {
  return api(`/campaigns/${id}`);
}

export function createCampaign(input: {
  groupId: string;
  subject: string;
  bodyTemplate: string;
  isHtml?: boolean;
  personalize?: boolean;
}): Promise<{ campaignId: string }> {
  return api(`/campaigns`, { method: "POST", body: { personalize: true, isHtml: false, ...input } });
}
